import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import IAppStore from "app/IAppStore";
import * as LoginActions from "./login.action";
import { useDispatch, useSelector } from "react-redux";
import useStartup from "common/ui/useStartup";
import loggingService from "common/logging/loggingService";

const LoginCallback: React.FC<any> = () => {

    const dispatch = useDispatch();
    const isLoggedIn = useSelector((store: IAppStore) => store.userState.isLoggedIn);
    const isLoginFailed = useSelector((store: IAppStore) => store.userState.isLoginFailed);
    const [accessToken, setAccessToken] = useState<string>(null);
    const [isAccessTokenSet, setIsAccessTokenSet] = useState<boolean>(false);
    const [returnUrl, setReturnUrl] = useState<string>(null);

    const { oktaAuth } = useOktaAuth();
    
    useStartup(() => {
      oktaAuth.storeTokensFromRedirect()
        .then(() => {
          setReturnUrl(oktaAuth.getOriginalUri());
          const token = oktaAuth.getAccessToken();
          setAccessToken(token);
          setIsAccessTokenSet(true);
        })
        .catch(err => {
          loggingService.error("Error handling login", err);
        });
    })

    if(isLoginFailed) {
      return <span />
    }

    if (isLoggedIn && isAccessTokenSet) {          
        return <Redirect to={returnUrl} />;
    }

    if (!isAccessTokenSet) {
      return <span />
    }

    if (accessToken == null) {
      return <Redirect to="/error" />;
    }
    else {
      LoginActions.login(accessToken)(dispatch);
      return <span />;
    }

}

export default LoginCallback;